import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { OrderSuccessModal } from "@/components/landing/OrderSuccessModal";
import { useApp } from "@/context/AppContext";
import { ROUTES } from "@/lib/routes";

export default function PaymentSuccessPage() {
  const [showModal, setShowModal] = useState(false);
  const { clearCart } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    clearCart();
    // Small delay so the page mounts before the modal opens
    const t = setTimeout(() => setShowModal(true), 300);
    return () => clearTimeout(t);
  }, []);

  const handleClose = () => {
    setShowModal(false);
    navigate(ROUTES.PRODUCTS, { replace: true });
  };

  return (
    <>
      {/* Blank background while modal is open */}
      <div className="min-h-screen flex items-center justify-center">
        {!showModal && (
          <div className="text-center space-y-3">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary mx-auto" />
            <p className="text-muted-foreground text-sm">Processing your payment…</p>
          </div>
        )}
      </div>
      <OrderSuccessModal open={showModal} onClose={handleClose} />
    </>
  );
}
